import { calculateAbweichung } from '@/utils/helperFunctions';
import { ArbeitsbereichCellContent } from '../cells/ArbeitsbereichCell';
import { ArbeitszeitCellArbeitszeitContent } from '../cells/ArbeitszeitCell';
import { MitarbeiterContent } from '../cells/MitarbeiterCell';
import { RowTypeMap } from '../entities/Entities';
import { CellContent } from '../ToDoTableContent';
import { CellRenderers } from './renderer';
import { DauerCellContent } from '../cells/DauerCell';
import { HinweiseCellContent } from '../cells/HinweiseCell';
import { ActionCellContentArbeitszeit } from '../cells/ActionCell';

const arbeitszeitRenderer: CellRenderers<RowTypeMap['arbeitszeit']> = {
  name: (row) => (
    <CellContent>
      <MitarbeiterContent mitarbeiter={row.mitarbeiter} />
    </CellContent>
  ),
  arbeitsbereich: (row) => (
    <CellContent>
      <ArbeitsbereichCellContent arbeitsbereich={row.arbeitsbereich} />
    </CellContent>
  ),
  arbeitszeit: (row) => (
    <CellContent>
      <ArbeitszeitCellArbeitszeitContent
        beginn={row.beginn}
        kommen={row.kommen}
        ende={row.ende}
        gehen={row.gehen}
        pausenDauer={row.getPausendauer()}
        pausen={row.pausen}
        id={row.id}
      />
    </CellContent>
  ),
  dauer: (row) => {
    let abweichung = undefined;
    if (row.beginn && row.ende) {
      abweichung = calculateAbweichung(
        row.beginn.abweichung,
        row.ende.abweichung,
      );
    }
    return (
      <CellContent>
        <DauerCellContent dauer={row.dauer} abweichung={abweichung} />
      </CellContent>
    );
  },
  hinweise: (row) => (
    <CellContent>
      <HinweiseCellContent
        rechtshinweise={row.rechtshinweise}
        zuschlaege={row.zuschlaege}
        termin={row.termin}
        bemerkung={row.bemerkung}
      />
    </CellContent>
  ),
  action: (row) => (
    <CellContent border={false}>
      <ActionCellContentArbeitszeit id={row.id} />
    </CellContent>
  ),
};

export default arbeitszeitRenderer;
